<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'PPPoE Plus Interface Config'" style="height: 430px">
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllPort"
                />
                <label for="idSelectAllPort"></label>
              </th>
              <th
                v-for="(value, key) in pppoeplusPortConfig.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in pppoeplusPortConfig.data"
              :key="row.port"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectPort' + index"
                  />
                  <label :for="'idRowSelectPort' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.port }}</div>
              </td>
              <td>
                <div>{{ row.pppoeplus }}</div>
              </td>
              <td>
                <div>{{ row.trust }}</div>
              </td>
              <td>
                <div>{{ row.strategy }}</div>
              </td>
              <td>
                <div>{{ row.dropPadi }}</div>
              </td>
              <td>
                <div>{{ row.dropPado }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowEditTable">
          <dialog-box
            :btitle="'PPPoE Plus Config'"
            style="min-height: 100%"
            @close="isShowEditTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="pppoeplus"
                  >PPPoE Plus</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="pppoeplus"
                    v-model="pppoeplusPortForm.pppoeplus"
                  >
                    <option label="enable" value="enable"></option>
                    <option label="disable" value="disable"></option>
                  </select>
                </div>
              </div>
              <div v-if="portIsPon == false" class="form-group">
                <label class="col-sm-3 control-label" for="trust"
                  >Trust Mode</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="trust"
                    v-model="pppoeplusPortForm.trust"
                  >
                    <option label="trust" value="trust"></option>
                    <option label="untrust" value="untrust"></option>
                  </select>
                </div>
              </div>
              <div v-if="portIsPon == false" class="form-group">
                <label class="col-sm-3 control-label" for="strategy"
                  >Strategy</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="strategy"
                    v-model="pppoeplusPortForm.strategy"
                  >
                    <option label="drop" value="drop"></option>
                    <option label="keep" value="keep"></option>
                    <option label="replace" value="replace"></option>
                  </select>
                </div>
              </div>
              <div v-if="portIsPon == false" class="form-group">
                <label class="col-sm-3 control-label" for="dropPadi"
                  >Drop Padi</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="dropPadi"
                    v-model="pppoeplusPortForm.dropPadi"
                  >
                    <option label="enable" value="enable"></option>
                    <option label="disable" value="disable"></option>
                  </select>
                </div>
              </div>
              <div v-if="portIsPon == true" class="form-group">
                <label class="col-sm-3 control-label" for="dropPado"
                  >Drop Pado</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="dropPado"
                    v-model="pppoeplusPortForm.dropPado"
                  >
                    <option label="enable" value="enable"></option>
                    <option label="disable" value="disable"></option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "pppoeplusPort",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      pppoeplusPortConfig: "",
      isShowEditTable: false,
      isSelectAll: false,
      iBox: {},
      portIsPon:false,
      pppoeplusPortForm: {
        pppoeplus: "",
        trust: "",
        strategy: "",
        dropPadi: "",
        dropPado: "",
      },
    }
  },

  created() {
    this.loadPppoeplusPortConfig()
  },

  methods: {
    loadPppoeplusPortConfig() {
      get("pppoeplusPortConfig")
        .then((res) => (this.pppoeplusPortConfig = res.data))
        .catch((err) => {
          this.pppoeplusPortConfig = en.pppoeplusPortConfig
        })
    },
    clkEdit() {
      for (let i = 0; i < this.pppoeplusPortConfig.data.length; i++) {
        if (this.pppoeplusPortConfig.data[i].selected == true) {
          if(this.pppoeplusPortConfig.data[i].port[0] == 'g'){
            this.portIsPon = true
          }else{
            this.portIsPon = false
          }
          this.pppoeplusPortForm.pppoeplus =
            this.pppoeplusPortConfig.data[i].pppoeplus
          this.pppoeplusPortForm.trust = this.pppoeplusPortConfig.data[i].trust
          this.pppoeplusPortForm.strategy =
            this.pppoeplusPortConfig.data[i].strategy
          this.pppoeplusPortForm.dropPadi =
            this.pppoeplusPortConfig.data[i].dropPadi
          this.pppoeplusPortForm.dropPado =
            this.pppoeplusPortConfig.data[i].dropPado
          this.isShowEditTable = true
          return
        }
      }
    },

    clkCancel() {
      this.isShowEditTable = false
    },

    changeSelectAll() {
      for (let i = 0; i < this.pppoeplusPortConfig.data.length; i++) {
        if (this.isSelectAll) {
          this.pppoeplusPortConfig.data[i].selected = true
        } else {
          this.pppoeplusPortConfig.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.pppoeplusPortConfig.data.length; i++) {
        this.pppoeplusPortConfig.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var pppoeplusConfig = {
        pppoeplus: this.pppoeplusPortForm.pppoeplus,
        trust: this.pppoeplusPortForm.trust,
        strategy: this.pppoeplusPortForm.strategy,
        dropPadi: this.pppoeplusPortForm.dropPadi,
        dropPado: this.pppoeplusPortForm.dropPado,
        portList:[]
      }
      for (let i = 0; i < this.pppoeplusPortConfig.data.length; i++) {
        if (this.pppoeplusPortConfig.data[i].selected) {
          pppoeplusConfig.portList.push({ port: this.pppoeplusPortConfig.data[i].port})
          /* 讨论目前一次配置一个端口 */
          break
        }
      }

      post("pppoeplusPortConfig", pppoeplusConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadPppoeplusPortConfig()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowEditTable = false
      this.selectNull()
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
